import React, { Component } from 'react';
import './ErrorContainer-theme.scss';
import { useTranslation } from '@scuf/localization';
import { HOCLocalization } from '../../utils/HOC/HOCLocalization';
interface ErrorContainerProps {
  statusCode?: number;
  headerText?: string;
  errorDescription?: string;
}
const ErrorContainer = (props: ErrorContainerProps) => {
  const errorHeading = props.headerText ? props.headerText : 'loadingError';
  const errorDesc = props.errorDescription
    ? props.errorDescription
    : 'contactAdmin';
  const [t] = useTranslation();
  return (
    <div className="error-block">
      {props.statusCode !== 204 && (
        <img src={require('../../assets/icons/svg/widget-error-icon.svg')} />
      )}
      <div className="heading">{t(errorHeading)}</div>
      <div className="sub-heading">{t(errorDesc)}</div>
    </div>
  );
};

export default HOCLocalization(ErrorContainer);
